.skeleton {
  display: block;
  background: color-mix(in srgb, var(--ink) 8%, var(--paper));
  border-radius: var(--radius-sharp);
  animation: pulse 1.6s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.55;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton {
    animation: none;
  }
}
